import React, { useState, useEffect } from 'react';
import '../../scss/style/gallery.scss'; // Ensure this path is correct for your project

function Gallery({ images }) {
    const [selectedImageIndex, setSelectedImageIndex] = useState(null);

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                closeImage();
            } else if (selectedImageIndex !== null) {
                if (event.key === 'ArrowLeft') {
                    goToPrevious();
                } else if (event.key === 'ArrowRight') {
                    goToNext();
                }
            }
        };

        window.addEventListener('keydown', handleKeyDown);

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [selectedImageIndex]);

    const openImage = (index) => {
        setSelectedImageIndex(index);
    };

    const closeImage = () => {
        setSelectedImageIndex(null);
    };

    const goToPrevious = () => {
        setSelectedImageIndex((prevIndex) => Math.max(prevIndex - 1, 0));
    };

    const goToNext = () => {
        setSelectedImageIndex((prevIndex) => Math.min(prevIndex + 1, images.length - 1));
    };

    return (
        <div className="gallery">
            <div className="main-image">
                <img
                    src={images[0].source}
                    alt={`Image ${images[0].id}`}
                    className="gallery-image large-image"
                    onClick={() => openImage(0)}
                />
            </div>
            <div className="thumbnail-list">
                {images.slice(1).map((image, index) => (
                    <img
                        key={index + 1}
                        src={image.source}
                        alt={`Image ${images[index + 1].id}`}
                        className="gallery-image"
                        onClick={() => openImage(index + 1)}
                    />
                ))}
            </div>

            {selectedImageIndex !== null && (
                <div className="modal">
                    <span className="close-button" onClick={closeImage}>&times;</span>
                    <img
                        src={images[selectedImageIndex].source}
                        alt={`Image ${images[selectedImageIndex].id}`}
                        className="modal-image"
                    />
                    <div className="navigation-left">
                        <button className='left-button' onClick={goToPrevious} disabled={selectedImageIndex === 0}>Previous</button>
                    </div>
                    <div className="navigation-right">
                        <button className='right-button' onClick={goToNext} disabled={selectedImageIndex === images.length - 1}>Next</button>
                    </div>
                </div>
            )}
        </div>
    );
}

export default Gallery;
